import { render, staticRenderFns } from "./SearchNews.vue?vue&type=template&id=e83e9218&scoped=true&"
import script from "./SearchNews.vue?vue&type=script&lang=js&"
export * from "./SearchNews.vue?vue&type=script&lang=js&"
import style0 from "./SearchNews.vue?vue&type=style&index=0&id=e83e9218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83e9218",
  null
  
)

export default component.exports